"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconDigitalPayment = function IconDigitalPayment(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M31.993 11.774A6.07 6.07 0 0 0 25.953 6H15.05l-.225.005A6.07 6.07 0 0 0 9 11.986V35.91l.005.283A6.07 6.07 0 0 0 15.047 42H25.95l.227-.005A6.07 6.07 0 0 0 32 35.954V33h-2v.97H11V12l.008-.2A4.07 4.07 0 0 1 15.054 8H25.95l.2.006A4.07 4.07 0 0 1 30 12.014V13h2v-1zM11 34.97v.944a4.07 4.07 0 0 0 3.82 4.079l.23.007h10.896a4.07 4.07 0 0 0 4.048-3.848L30 35.95v-.98zm12-24v1h-4v-1zm17 4H21a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h19a3 3 0 0 0 3-3v-11a3 3 0 0 0-3-3m-19 2h19a1 1 0 0 1 1 1v7H20v-7a1 1 0 0 1 1-1m-1 10h21v2a1 1 0 0 1-1 1H21a1 1 0 0 1-1-1zm1.81 10.81a.91.91 0 1 1-1.82 0 .91.91 0 0 1 1.82 0",
    clipRule: "evenodd"
  })));
};

export { IconDigitalPayment, IconDigitalPayment as default };
